// @flow

import { observer } from "mobx-react";
import React from "react";

import NotificationModel, { types } from "app/models/Notification";

import "./Notification.scss";

type Props = {
    notification: NotificationModel,
    onRemove: Function
};

@observer
export default class Notification extends React.Component<Props> {
    onRemove = () => {
        this.props.onRemove(this.props.notification);
    };

    icon() {
        const type = this.props.notification.type;
        if (type === types.SUCCESS) return "check";
        return type === types.WARNING ? "exclamation-triangle" : "remove";
    }

    render() {
        const notification = this.props.notification;
        const icon = this.icon();

        const classes = ["Notification"];
        const typeClass =
            notification.type === types.ERROR ? "danger" : notification.type;
        classes.push(`alert alert-dismissible alert-${typeClass}`);

        return (
            <div className={classes.join(" ")} role="alert">
                <button type="button" className="close" onClick={this.onRemove}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <i className={`fa fa-${icon}`} /> {notification.message}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Notification/Notification.js